import { formatSecondsToMMSS } from "../../../utils/format";
import { useNavigationStore } from "../../../store/navigationStore";

export default function NavDetail() {
  const distance = useNavigationStore((state) => state.remainingDistance);
  const duration = useNavigationStore((state) => state.remainingDuration);

  return (
    <div className="mb-[8px] md:mb-0 flex items-center">
      <span className="text-[15px]">
        {distance === -1 ? "-" : distance.toFixed(0)}m |{" "}
        {duration === -1 ? "--:--" : formatSecondsToMMSS(duration)}
      </span>
    </div>
  );
}
